var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mention-box',{attrs:{"items":_vm.items},on:{"mention-select":_vm.handleVariableClick},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('span',{staticClass:"text-capitalize variable--list-label"},[_vm._v("\n      "+_vm._s(item.description)+"\n    ")]),_vm._v("\n    ("+_vm._s(item.label)+")\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }